var _path, _path2, _path3, _path4, _tspan, _tspan2, _rect, _g, _circle, _circle2, _circle3, _tspan3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186.197,
    height: 186.345,
    viewBox: "0 0 186.197 186.345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_798",
    "data-name": "Groupe 798",
    transform: "translate(0 0.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_11",
    "data-name": "Groupe 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_10",
    "data-name": "Groupe 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-Approve"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1425",
    "data-name": "Rectangle 1425",
    d: "M0,110.535H186.148v59.26A16.2,16.2,0,0,1,169.943,186H16.2A16.2,16.2,0,0,1,0,169.795v-59.26Z",
    fill: "#064b93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1426",
    "data-name": "Rectangle 1426",
    d: "M186.148,110.535H0V18.5A18.646,18.646,0,0,1,18.647-.148H167.5A18.646,18.646,0,0,1,186.148,18.5v92.036Z",
    fill: "#1794cd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1452",
    "data-name": "Trac\\xE9 1452",
    d: "M103.024,25.414a61.7,61.7,0,0,1,30.73,14.271c-2.623,2.392-5.17,4.88-7.63,7.393a51.341,51.341,0,1,0,17.57,29.465,90.146,90.146,0,0,1,9.521-5.71,61.994,61.994,0,1,1-50.2-45.409",
    fill: "#004b93",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1453",
    "data-name": "Trac\\xE9 1453",
    d: "M57.979,73.291a61.784,61.784,0,0,1,24.7-10.579c5.814,9.166,10.584,21.583,11.464,29.831,19.825-25.62,44.576-57.374,67.923-62.065a104.371,104.371,0,0,0-6.809,33.682c-25.065,7.353-48.962,35.94-65.445,55.016-5.824-15.454-16.444-38.3-31.829-45.885",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "AP",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "AP-2",
    "data-name": "AP",
    transform: "translate(51.987 169.229)",
    fill: "#fff",
    fontSize: 61.211,
    fontFamily: "Young",
    letterSpacing: "0.03em",
    style: {
      isolation: "isolate"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AP"))), /*#__PURE__*/React.createElement("text", {
    id: "AP-3",
    "data-name": "AP",
    transform: "translate(51.987 169.229)",
    stroke: "#feffff",
    strokeWidth: 0.6,
    fontSize: 61.211,
    fontFamily: "Young",
    letterSpacing: "0.03em",
    fill: "none",
    style: {
      isolation: "isolate"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "AP"))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1465",
    "data-name": "Rectangle 1465",
    width: 186.197,
    height: 186.197,
    rx: 18.506,
    transform: "translate(0 0)",
    fill: "#004b93"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ligne_1",
    "data-name": "Ligne 1",
    d: "M94.25,155.126H90.663V95.649H94.25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M145.457,125.693h-25.9a6.581,6.581,0,0,1-6.573-6.573V95.649h3.583V119.12a2.99,2.99,0,0,0,2.987,2.986h25.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M65.361,125.693h-25.9v-3.587h25.9a2.99,2.99,0,0,0,2.986-2.986V95.649h3.587V119.12A6.581,6.581,0,0,1,65.361,125.693Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    "data-name": "Trac\\xE9 14",
    d: "M131.507,95.649a25.108,25.108,0,1,0-8.818-48.6,34.823,34.823,0,0,0-69.22,4.151,21.791,21.791,0,0,0-2.853-.2,22.316,22.316,0,0,0,0,44.633h80.891Z",
    fill: "#fff"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 13.047,
    cy: 13.047,
    r: 13.047,
    transform: "translate(26.411 110.852)",
    fill: "#fbba00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 13.047,
    cy: 13.047,
    r: 13.047,
    transform: "translate(79.41 142.078)",
    fill: "#98c226"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 13.047,
    cy: 13.047,
    r: 13.047,
    transform: "translate(134.635 110.852)",
    fill: "#0094cd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "C-3",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "C",
    transform: "translate(67.166 83.561)",
    fill: "#004b93",
    fontSize: 69,
    fontFamily: "ArialMT, Arial",
    style: {
      isolation: "isolate"
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoConnect);
export default __webpack_public_path__ + "static/media/Logo-Connect.1889c05b43c0143fc54684d6a4bf11f7.svg";
export { ForwardRef as ReactComponent };